const THEME_STORAGE_KEY = 'pragmatic-ui-theme';

function getPreferredTheme() {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    // ignore read errors
  }

  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  return 'light';
}

function applyTheme(theme) {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.classList.toggle('dark', theme === 'dark');
}

function persistTheme(theme) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // ignore write errors
  }
}

function syncToggleUI(theme) {
  const toggles = document.querySelectorAll('[data-theme-toggle]');
  const isDark = theme === 'dark';

  toggles.forEach((toggle) => {
    const sunIcon = toggle.querySelector('[data-theme-icon-sun]');
    const moonIcon = toggle.querySelector('[data-theme-icon-moon]');

    if (sunIcon) sunIcon.classList.toggle('hidden', isDark);
    if (moonIcon) moonIcon.classList.toggle('hidden', !isDark);
  });
}

export function initThemeToggle() {
  const toggles = document.querySelectorAll('[data-theme-toggle]');
  if (!toggles.length) return;

  let currentTheme = getPreferredTheme();
  applyTheme(currentTheme);
  syncToggleUI(currentTheme);

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      currentTheme = currentTheme === 'dark' ? 'light' : 'dark';
      applyTheme(currentTheme);
      persistTheme(currentTheme);
      syncToggleUI(currentTheme);
    });
  });
}
